// extracted by mini-css-extract-plugin
export default {"wrapper":"itemPage_wrapper__YjweQ"};